import { all, put, takeLatest } from 'redux-saga/effects';
import { requestApi2 } from '../../../../lib/request';
import { CompanyMapper } from '../../../common/schemes/company/mapper';
import { LineMapper } from '../../../common/schemes/line/mapper';
import * as action from '../actions';
import { constants, services } from '../config';

export function* getCompanyLinesSaga(body) {
  try {
    const response = yield requestApi2(services.getCompanyLines(body));

    if (response && response.status >= 200 && response.status < 300) {
      const { data } = response;

      yield put(action.getCompanyLinesSuccess(data?.map((el) => LineMapper.hydrate(el))));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.getCompanyLinesFail(error));
  }
}

export function* getCompany(companyUuid) {
  try {
    const response = yield requestApi2(services.getCompany(companyUuid));
    if (response && response.status >= 200 && response.status < 300) {
      const { data } = response;

      yield put(action.getCompanySuccess(CompanyMapper.hydrate(data)));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.getCompanyLinesFail(error));
  }
}

function* actionWatcher() {
  yield takeLatest(constants.GET_COMPANY_LINE, getCompanyLinesSaga);
  yield takeLatest(constants.GET_COMPANY, getCompany);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
